import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import './PageHeader.css';

const PageHeader = ({ title }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Use window scroll position since that's what's actually scrolling
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      
      // When scrolled more than 50px, make it shrink
      if (scrollTop > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    // Listen to window scroll
    window.addEventListener('scroll', handleScroll);
    
    // Initial check
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div 
      className={`page-title-header-fixed ${isScrolled ? 'scrolled' : ''}`}
    >
      <Container>
        <h1 className="page-title">{title}</h1>
      </Container>
    </div>
  );
};

export default PageHeader;
